import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario3IncorrectPtAdmittedAudioCaching, scenario3IncorrectPtAdmittedVideoSegments } from "../../../scenario3-incorrect-pt-admitted";
import { IncorrectPtAdmittedComponentsStep2ComponentMainConfig, IncorrectPtAdmittedComponentsStep2ComponentPart1Config } from "../incorrect-pt-admitted-components-step2";

export default class IncorrectPtAdmittedComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): IncorrectPtAdmittedComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: IncorrectPtAdmittedComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario3IncorrectPtAdmittedAudioCaching.getItemByKey(scenario3IncorrectPtAdmittedAudioCaching.audioKeys.question5).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. There is no history involving this type of occurrence with the employee.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. There is no history involving this type of occurrence with the employee.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, process.env.PUBLIC_URL + '/assets/images/scenarios/step2-image.png', mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		}, 4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 3 - Breach of Confidentiality',
			recapFirst: 'In summary this is “At Risk Behavior.”',
			htmlData: `
				<br/><li>The substitution test is satisfied. 
				<br/><br/></li><li>Accountability is shared between the leadership and the employee.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}